export default "__VITE_ASSET__CV5lwr_b__"